import styled from 'styled-components';

import { Separator } from '@dreryk/react-components';

export const StyledStageField = styled.div`
   display: flex;
   flex-direction: column;
   gap: 8px;
`;
StyledStageField.displayName = 'StyledStageField';

export const StyledStagePanel = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;
   padding: 20px;
   background: ${({ theme }) => theme.backgroundLightest};
   border-radius: 8px;
`;
StyledStagePanel.displayName = 'StyledStagePanel';

export const StyledTimesOfDayGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 12px;
`;
StyledTimesOfDayGrid.displayName = 'StyledTimesOfDayGrid';

export const StyledStageSeparator = styled(Separator)`
   &:before {
      margin-top: 0;
      margin-bottom: 0;
   }
`;

StyledStageSeparator.displayName = 'StyledStageSeparator';
